import { SnLonLat, SnLonLatLike } from '@lib/geo/helpers';

import { IMapMarkerBaseEvents } from './base-marker-events';
import { IMapMarkerOptions } from './marker-options';

export abstract class BaseMarker<TEvents extends IMapMarkerBaseEvents = IMapMarkerBaseEvents> {
  protected lonLat: SnLonLat;
  protected title: string;
  public id: string;

  protected constructor(options?: IMapMarkerOptions) {
    options = {
      title: '',
      ...options,
    };

    this.id = options.id;
    this.title = options.title;
    this.lonLat = options.lonLat ? SnLonLat.convert(options.lonLat) : undefined;
  }

  public getLonLat(): SnLonLat {
    return this.lonLat;
  }

  public setLonLat(lonLatLike: SnLonLatLike): this {
    this.lonLat = SnLonLat.convert(lonLatLike);

    return this;
  }

  public getId(): string {
    return this.id;
  }

  public getTitle(): string {
    return this.title;
  }

  public setTitle(title: string): this {
    if (this.title !== title) {
      this.title = title;
    }

    return this;
  }
}
